<template>
	<div>
	<el-dialog  title="新建邮件模板" :visible.sync="yjmbdiag"  width="900px" :close-on-click-modal="false"  append-to-body >
		<!-- <minhead :headtitle="yjmbtitle" :isdiag="true"></minhead> -->
		<div class="Centerhorizontally topdao" >
			<div class="between-line" style="width: 800px;">
			<div>
				<span>邮件种类</span>
				<el-select v-model="emailFrom.youjzl" placeholder="请选择" style="width: 160px;margin-left: 10px;">
					<el-option v-for="item in selectYouJzl" :key="item.key" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</div>
			<div>
				<span>模板名称</span>
				<el-input v-model="emailFrom.mubmc" maxlength="60" style="width: 160px;margin-left: 10px;" ></el-input>
			</div>
			<div>
				<span>是否默认</span>
				<el-select v-model="emailFrom.shifmr" placeholder="请选择" style="width: 100px;margin-left: 10px;">
					<el-option v-for="item in selectShiFmr" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</div>
			</div>
		</div>
		<div class="Centerhorizontally topdao"  style="margin-top: 20px;">
			<div class="between-line" style="width: 800px;">
				<span>主题</span>
				<el-input style="width: 700px;" v-model="emailFrom.zhut" maxlength="200" ></el-input>
			</div>
		</div>
		<div class="Centerhorizontally topdao"  style="margin-top: 20px;">
			<div class="between-line" style="width: 800px;">
				<span>邮件内容</span>
				<div style="width: 680px;" ></div>
			</div>
		</div>
		<div class="Centerhorizontally topdao"  style="margin-top: 20px;">
			<div class="between-line" style="width: 800px;">
				<quill-editor ref="myTextEditor" v-model="emailFrom.neir" :options="editorOption" ></quill-editor>
			</div>
		</div>
		<div class="Centerhorizontally topdao" style="margin-top: 20px;" >
			<div class="between-line" style="width: 800px;">
				<span>描述</span>
				<el-input v-model="emailFrom.miaos" maxlength="200" style="width:700px;" ></el-input>
			</div>
		</div>
		<div style="margin-top: 30px;padding-bottom: 28px;" class="between-line">
			<div></div>
			<div class="rightbuttom">
				<div @click="sbumitFrom">保存</div>
				<div @click="yjmbdiag = false">关闭</div>
			</div>
		</div>
		</el-dialog>
		<minhead :headtitle="headtitle"></minhead>
		<div class="areacontent">
			<div class="between-line">
				<div class="Centerupdown">
				<!-- 	<el-button type="primary" plain style="width: 100px;" @click="foradd">
						新建
						<i class="el-icon-circle-plus-outline el-icon--right"></i>
					</el-button> -->
					<div class="addstyle" style="width: 100px;margin-right: 24px;" @click="foradd">
						<samp>	新建
						<i class="el-icon-circle-plus-outline el-icon--right"></i></samp>
					</div>
					<!--<el-button type="primary" plain style="width: 100px;"  @click="foredit">
						编辑
						<i class="el-icon-edit-outline el-icon&#45;&#45;right"></i>
					</el-button>
					<el-button type="primary" plain style="width: 100px;">
						删除
						<i class="el-icon-delete el-icon&#45;&#45;right"></i>
					</el-button>-->
					<!--<el-button type="primary" plain style="width: 100px;">
						重置
						<i class="el-icon-refresh el-icon&#45;&#45;right"></i>
					</el-button>-->
				</div>
				<div class="Centerupdown">
					<el-input style="width: 250px;margin-left: 20px;margin-right: 16px;" placeholder="模板名称、更新人、描述" prefix-icon="el-icon-search" clearable v-model="serchval" @input="getEmailTemplateByparam"></el-input>
				</div>
			</div>
			<div class="areatable">
				<div class="tableh">
				<el-table :data="tableData" border style="width: 100%"  @selection-change="handleSelectionChange"   height="calc(100vh - 262px )" ref="multipleTable">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="youjzl" label="邮件种类"  align="center" :formatter="stateFormat"></el-table-column>
					<el-table-column prop="zhut" label="主题" align="center"></el-table-column>
					<el-table-column prop="mubmc" label="模板名称" align="center"></el-table-column>
					<el-table-column prop="miaos" label="描述" align="center"></el-table-column>
					<el-table-column prop="genxr" label="更新人" align="center"></el-table-column>
					<el-table-column label="是否默认" align="center">
						<template slot-scope="scope">
							<span :style="scope.row.shifmr==1?'color:#3C6EF5':'color:#D2D2D2'">{{scope.row.shifmr==1?"是":"否"}}</span>
							
							<el-switch style="margin-left: 10px;"
							  v-model="scope.row.shifmr"
							  active-color="#3C6EF5"
							   active-value="1"
							   inactive-value="0"
							  inactive-color="#D2D2D2" @change="changeshifmr(scope.row,scope.row.shifmr)">
							</el-switch>
						</template>
					</el-table-column>
					<el-table-column label="创建时间" align="center">
						<template slot-scope="scope">
							<span>{{formatdate(scope.row.createTime)}}</span>
						</template>
					</el-table-column>
					<el-table-column  fixed="right" label="操作">
						<template slot-scope="scope">
							<el-button type="text" size="small"  @click="foredit(scope.row)">编辑</el-button>
							<el-button type="text" size="small"  @click="deleteData(scope.row)">删除</el-button>
						</template>


					</el-table-column>
				</el-table>
				</div>
				<div class="buttompage">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[10, 20, 100, 500]"
						:page-size="pagenum"
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalcount"
					></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import 'quill/dist/quill.core.css';
	import 'quill/dist/quill.snow.css';
	import 'quill/dist/quill.bubble.css';
	import { quillEditor } from 'vue-quill-editor';
export default {
	
	components: {
	    quillEditor
	},
	data() {
		return {
			content: '',
			editorOption: {
			    placeholder: 'Hello World'
			},
			page: 1,
			pagenum: 10,
			yjmbdiag:false,
			totalcount: 10,
			tableData: [],
			headtitle: ['系统设置', '邮件模板配置'],
			yjmbtitle:['新建邮件模板'],
			serchval: '',
			selectYouJzl:'',
			emailFrom:{
				qiybh:'',
				youjzl:'',
				mubmc:'',
				miaos:'',
				shifmr:'',
				zhut:'',
				neir:'',
				genxr:'',
				id:'',
				version:'',
				createTime:'',
				updateTime:''
			},
			selectShiFmr:[{value:'0',label:'是'},{value:'1',label:'否'}],
			tableHeight:""
		};
	},
	created() {
		this.initYouJzl();
		this.getEmailTemplateByparam();
	},
	mounted() {
		 this.$nextTick(() =>{
			this.tableHeight = this.diagheight();this.$refs.multipleTable.doLayout()
			window.onresize = () =>{
		    this.tableHeight = this.diagheight();this.$refs.multipleTable.doLayout()
		      }
		    })
	},
	methods: {
		foradd(){
			this.resetFrom();
			this.yjmbdiag=true;

		},
		foredit(row){
			//编辑功能
			console.log(row);
			this.resetFrom();
			this.yjmbdiag=true;
			this.emailFrom=JSON.parse(JSON.stringify(row))
		},
		deleteData(row){
			/*if(row.shifmr=='1'){
				this.$message.error("默认邮件模板无法删除。");
				return;
			}*/
			this.$https.fetchPost('/sys/email/deleteEmailTemplate', row.id).then(res => {
				console.log(res);
				if(res.data.success){
					this.yjmbdiag = false
					this.getEmailTemplateByparam();
					return;
				}

			});
		},
		handleSizeChange(val) {
			this.pagenum = val;
			this.getEmailTemplateByparam();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.getEmailTemplateByparam();
		},
		getEmailTemplateByparam(){
			let param={}
			param.pagenum = this.pagenum;
			param.page = this.page;
			param.serchval=this.serchval;
			this.$https.fetchPost('/sys/email/getEmailTemplateByparam', param).then(res => {
				this.tableData = res.data.obj.data;
				this.totalcount = res.data.obj.count;
			});
		},
		initYouJzl(){
			this.$https.fetchPost('config/getSelectByKey', "EMAILTEMPLATE_YOUJZL").then(res => {
				this.selectYouJzl = this.setSelectKey(JSON.parse(res.data.obj));
			});
		},
		sbumitFrom(){
			//提交编辑或是修改请求
			if(this.checkFrom()){
				console.log(this.emailFrom);
				if(this.emailFrom.id==""){
					this.$https.fetchPost('/sys/email/saveEmailTemplate', this.emailFrom).then(res => {
						console.log(res);
						if(res.data.success){
							this.yjmbdiag = false
							this.getEmailTemplateByparam();
							return;
						}

					});
				}else{
					this.$https.fetchPost('/sys/email/updateEmailTemplate', this.emailFrom).then(res => {
						console.log(res);
						if(res.data.success){
							this.yjmbdiag = false
							this.getEmailTemplateByparam();
							return;
						}

					});
				}



			}
		},

		handleSelectionChange(e){
			//表格功能修改
			console.log(e);
		},
		resetFrom(){
			//清除表格中的值
			Object.keys(this.emailFrom).map(key => (this.emailFrom[key] = ''));
		},
		checkFrom(){
			if(this.emailFrom.youjzl==""){
				this.$message.error("请选择邮件种类。");
				return false;
			}else if(this.emailFrom.mubmc==""){
				this.$message.error("请输入模板名称。");
				return false;
			}else if(this.emailFrom.shifmr==""){
				this.$message.error("请选择是否默认。");
				return false;
			}else if(this.emailFrom.zhut==""){
				this.$message.error("请输入邮件主题。");
				return false;
			}else if(this.emailFrom.neir==""){
				this.$message.error("请输入邮件内容。");
				return false;
			}else if(this.emailFrom.miaos==""){
				this.$message.error("请输入描述。");
				return false;
			}else{
				return true;
			}
		},
		stateFormat(row, column, cellValue, index) {
			for (let i=0;i<this.selectYouJzl.length;i++){
				if(this.selectYouJzl[i].value==row.youjzl){
					return this.selectYouJzl[i].label;
				}
			}
			return row.youjzl;
		},
		changeshifmr(row,sfmr){
			console.log(sfmr);
			if(sfmr==1){
				row.shifmr=1;
			}else{
				row.shifmr=0;
			}
			this.$https.fetchPost('/sys/email/updateEmailTemplate', row).then(res => {
				console.log(res);
				if(res.data.success){
					this.yjmbdiag = false
					this.getEmailTemplateByparam();
					return;
				}
			});
		}
	}
};
</script>

<style scoped="scoped" lang="less">
	.topdao{
		font-size: 18px;
		font-weight: 400;
		color: #0080FF;
		margin-right: 10px;
	}
// /deep/.el-dialog__body {
// 	padding: 0;
// }
/deep/.el-table--small td {
	padding: 4px 0;
}
/deep/.el-table__body-wrapper {
	min-height: 160px;
}


.areatable {
	margin-top: 27px;
}
.areacontent {
	margin-left: 21px;
}
</style>
